import React from 'react';
import PropTypes from 'prop-types';

import { Box, Paper, IconButton } from '@material-ui/core';
import i18n from 'i18n-js';
import { Table } from 'components/UI';
import Edit from '@material-ui/icons/Edit';
import VersionStatus from './VersionStatus';
import DeleteIcon from '@material-ui/icons/Delete';
import StarOutlinedIcon from '@material-ui/icons/StarOutlined';
import StarBorderOutlinedIcon from '@material-ui/icons/StarBorderOutlined';

const actionIconStyle = { color: '#777777' };
const defaultVersionIcon = { color: '#FFB027' };

const DocumentVersionsTable = ({
  page,
  limit,
  versions,
  handleEdit,
  handleDelete,
  defaultSortAsc,
  defaultSortField,
  handlePageChange,
  handleMarkDefault,
  loading,
  pagination,
  handleRowClick,
  handleSort,
  handlePerRowsChange,
}) => {
  const columns = [
    {
      name: i18n.t('tableColumns.id'),
      selector: 'id',
      sortable: true,
      grow: 0,
    },
    {
      name: i18n.t('tableColumns.name'),
      selector: (row) => (row?.version ? row.version : '--'),
    },
    {
      name: i18n.t('tableColumns.status'),
      selector: (row) => (row?.status ? <VersionStatus status={row?.status} /> : '--'),
    },
    {
      name: i18n.t('tableColumns.file'),
      selector: (row) => (row?.files?.length > 0 ? row.files[0]?.filename : '--'),
      grow: 1,
    },
    {
      name: i18n.t('tableColumns.action'),
      selector: (row) => {
        return (
          <Box display="flex">
            <IconButton aria-label="delete" onClick={() => handleEdit(row)}>
              <Edit fontSize="inherit" />
            </IconButton>
            <IconButton aria-label="delete" onClick={() => handleDelete(row.id)}>
              <DeleteIcon fontSize="inherit" />
            </IconButton>
            <IconButton
              aria-label="delete"
              disabled={row.default}
              onClick={() => handleMarkDefault(row)}
            >
              {row.default ? (
                <StarOutlinedIcon style={defaultVersionIcon} />
              ) : (
                <StarBorderOutlinedIcon style={actionIconStyle} />
              )}
            </IconButton>
          </Box>
        );
      },
      grow: 1,
    },
  ];

  return (
    <Paper elevation={2}>
      <Table
        page={page}
        limit={limit}
        data={versions}
        columns={columns}
        loading={loading}
        onSort={handleSort}
        defaultSortAsc={defaultSortAsc}
        handleRowClicked={handleRowClick}
        defaultSortField={defaultSortField}
        handlePageChange={handlePageChange}
        totalRows={pagination?.totalRows || 0}
        handlePerRowsChange={handlePerRowsChange}
      />
    </Paper>
  );
};

DocumentVersionsTable.propTypes = {
  /**
   * Table data
   */
  versions: PropTypes.any,
  /**
   * A handler to set a version as default
   */
  handleMarkDefault: PropTypes.func,
  /**
   * A handler to delete a version
   */
  handleDelete: PropTypes.func,
  /**
   * A handler to edit a version
   */
  handleEdit: PropTypes.func,
};

DocumentVersionsTable.defaultProps = {
  versions: [],
  handleEdit: () => {},
  handleDelete: () => {},
  handleMarkDefault: () => {},
};

export default DocumentVersionsTable;
